/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

// import parse from 'html-react-parser';

// import { ToastContainer, toast } from 'react-toastify';     //토스트(toast)
import moment from 'moment';
import { isMobile } from 'react-device-detect';
//import $ from 'jquery';
import ReactPlayer from 'react-player';
import Slider from 'react-slick';

import Timer from 'react-timer-wrapper';
// import Timecode from 'react-timecode';

import ItemBox from '../../components/aketo/ItemBox';
import VoteSch2025 from '../../components/aketo/VoteSch2025';
import '../../css/event251103.css';

class Event2025_aketo extends PureComponent {
  state = {
    slideIndex: 0,
    slidePlay: true,
    videoUrl: 'https://youtu.be/QGYX6oRzVfc',
    duration: 10000,
    time: 0,
    charList: [],
    eventIdx: 309,
    groupCode: 1,
    // open:
    //   moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
    //     '2024-12-03 18:40:00' &&
    //   moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <= '2024-12-03 19:30:00'
    //     ? true
    //     : false,
    open: false, // 동영상 팝업.

    countdown:
      moment(new Date()).format('YYYY-MM-DD HH:mm:ss') < '2025-12-03 16:00:00'
        ? true
        : false,
    //countdown: false,

    playing: false,
  };
  voteUrl = 'https://aketo.aniplustv.com';
  stage = '32강';

  componentDidMount = () => {
    // const { groupCode } = this.state;
    const curDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
    const endDate = moment('2025-12-03 16:00:00'); //2024-12-02 16:00:00
    const diffTime = endDate.diff(curDate);

    if (diffTime <= 0) {
      this.setState({
        duration: 0,
        countdown: false,
      });
    } else {
      this.setState({
        duration: diffTime,
      });
    }

    //console.log(diffTime)
    // this._getUrl();
    this._getData(13, 1);

    if (this.video) {
      this.video.seekTo(0);
      setTimeout(() => {
        this.setState({
          playing: true,
        });
      }, 500);
    }
    /*
        setTimeout(()=>{
            this._getData(9, 2)
        }, 500)+
        */
  };
  _getUrl = async () => {
    const result = await this._getUrlApi();
    const intReturn = result.data[0].intReturn;
    const urlData = result.data[0].listData;

    if (intReturn === 0) {
      const pos = urlData[0].url.lastIndexOf('/');
      const chat = urlData[0].url.substr(pos + 1, urlData[0].url.length);
      console.log(chat);

      this.setState({
        videoUrl: urlData[0].url,
        chatUrl: chat,
        gubun: urlData[0].gubun,
      });
    }
  };
  _getUrlApi = () => {
    const { apiUrl } = this.props;

    return axios.post(apiUrl + '/event_202212_aketo_url', {
      params: {},
    });
  };
  _getData = async (cupIdx, groupCode) => {
    console.log('call');
    const result = await this._getDataApi(cupIdx, groupCode);
    const intReturn = result.data[0].intReturn;
    const list = result.data[0].listData;
    console.log(list);
    if (intReturn === 0) {
      this.setState({
        charList: list,
        //charList: this.state.charList.concat(list),
      });
    }
  };
  _getDataApi = (cupIdx, groupCode) => {
    const { apiUrl } = this.props;
    let stageCode = 'F0032';

    const today = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

    if (today >= '2025-12-03 16:00:00' && today < '2025-12-08 16:00:00') {
      stageCode = 'F0032';
    } else if (
      today >= '2025-12-08 16:00:00' &&
      today < '2025-12-15 16:00:00'
    ) {
      stageCode = 'F0016';
    } else if (
      today >= '2025-12-15 16:00:00' &&
      today < '2025-12-22 12:00:00'
    ) {
      stageCode = 'F0008';
    } else if (
      today >= '2025-12-22 12:00:00' &&
      today < '2025-12-26 12:00:00'
    ) {
      stageCode = 'F0004';
    } else if (today >= '2025-12-26 12:00:00') {
      stageCode = 'F0002';
    }

    return axios
      .post(apiUrl + '/aketo_32_list', {
        params: {
          cupIdx: cupIdx,
          groupCode: groupCode,
          stageCode: stageCode,
        },
      })
      .then((resposne) => resposne)
      .catch((error) => {
        //console.log('error...')
      });
  };

  // _goVote = () => {
  //   window.open(
  //     'https://aketo.aniplustv.com/#/ranking/aketo_view.asp?gCode=RA&sCode=004&idx=111&event_id=9',
  //     'aketo',
  //     ''
  //   );
  // };
  /*
    _chageItem = (index) => {
        setTimeout(()=>{
            this._getData(9, index+1)
        }, 1000)
    }
    */
  _beforChange = (current, next) => {
    //console.log('beforChange' + next)
    //this._chageItem(next)
    this.setState({ slideIndex: next });
    //this._getData(10, next)
  };
  _afterChange = (index, idx) => {
    console.log('afterChange===' + index);
    this._getData(13, index + 1);
  };
  _onNext = () => {
    this.slider.slickNext();
  };
  _onPrev = () => {
    this.slider.slickPrev();
  };
  _onGoto = (i) => {
    this.slider.slickGoTo(i);
  };
  _renderItem = () => {
    const { charList } = this.state;

    const today = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
    let num = 0;
    if (today >= '2025-12-03 16:00:00' && today <= '2025-12-08 16:00:00') {
      num = 8;
      this.stage = '32강';
    } else if (
      today >= '2025-12-08 16:00:00' &&
      today < '2025-12-15 16:00:00'
    ) {
      num = 4;
      this.stage = '16강';
    } else if (
      today >= '2025-12-15 16:00:00' &&
      today < '2025-12-22 12:00:00'
    ) {
      num = 4;
      this.stage = '8강';
    } else if (
      today >= '2025-12-22 16:00:00' &&
      today < '2025-12-26 12:00:00'
    ) {
      num = 2;
      this.stage = '4강';
    } else if (today >= '2025-12-26 12:00:00') {
      num = 2;
      this.stage = '결승';
    }

    return Array.from(Array(num), (e, i) => {
      return <ItemBox key={i} i={i} charList={charList} />;
    });
  };
  onTimerUpdate = ({ time, duration }) => {
    //console.log(duration - time)
    const gap = duration - time;
    const day = String(Math.floor(gap / (1000 * 60 * 60 * 24))).padStart(
      2,
      '0'
    ); // 일
    const hh = String(Math.floor((gap / (1000 * 60 * 60)) % 24)).padStart(
      2,
      '0'
    ); // 시
    const mm = String(Math.floor((gap / (1000 * 60)) % 60)).padStart(2, '0'); // 분
    const ss = String(Math.floor((gap / 1000) % 60)).padStart(2, '0'); // 초

    //console.log(new Date(203010231540))
    /*
        const date = new Date(duration - time)
        const day = moment(date).format('DD')
        const hh = moment(date).format('hh')
        const mm = moment(date).format('mm')
        const ss = moment(date).format('ss')
        */
    //console.log(day, hh, mm, ss)
    this.setState({
      time,
      duration,
      day,
      hh,
      mm,
      ss,
    });
  };
  onFinish = () => {
    //console.log('투표종료')
    this.setState({
      countdown: false,
    });
  };
  _close = () => {
    this.video.seekTo(0);
    setTimeout(() => {
      this.setState({
        open: false,
        playing: false,
      });
    }, 500);
  };
  _open = () => {
    this.setState({
      open: true,
      playing: true,
    });

    setTimeout(() => {
      this.video.seekTo(0);
    }, 500);
  };
  _vote = () => {
    const today = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
    console.log(today);

    if (today < '2025-11-19 16:00:00') {
      alert('1차예선은 11월 19일 오후 4시에 시작됩니다.');
    } else if (
      today >= '2025-11-19 16:00:00' &&
      today <= '2025-11-24 16:00:00'
    ) {
      window.open(`${this.voteUrl}/2025/pre/round-1`, 'aketo', '');
    } else if (today > '2025-11-24 16:00:00' && today < '2025-11-26 16:00:00') {
      alert('2차 예선은 11월 26일 오후 4시에 시작됩니다.');
    } else if (
      today >= '2025-11-26 16:00:00' &&
      today <= '2025-12-01 16:00:00'
    ) {
      window.open(`${this.voteUrl}/2025/pre/round-2`, 'aketo', '');
    } else if (today > '2025-12-01 16:00:00' && today < '2025-12-03 16:00:00') {
      alert('32강은 12월 03일 오후 4시에 시작됩니다.');
    } else if (
      today >= '2025-12-03 16:00:00' &&
      today <= '2025-12-08 16:00:00'
    ) {
      window.open(`${this.voteUrl}/2025/tournament/round-32`, 'aketo', '');
    } else if (today > '2025-12-08 16:00:00' && today < '2025-12-10 16:00:00') {
      alert('16강은 12월 10일 오후 4시에 시작됩니다.');
    } else if (
      today >= '2025-12-10 16:00:00' &&
      today <= '2025-12-15 16:00:00'
    ) {
      window.open(`${this.voteUrl}/2025/tournament/round-16`, 'aketo', '');
    } else if (today > '2025-12-15 16:00:00' && today < '2025-12-17 12:00:00') {
      alert('8강은 12월 17일 오후 6시에 시작됩니다.');
    } else if (
      today >= '2025-12-17 18:00:00' &&
      today <= '2025-12-22 12:00:00'
    ) {
      window.open(`${this.voteUrl}/2025/tournament/round-8`, 'aketo', '');
    } else if (today > '2025-12-22 12:00:00' && today < '2025-12-26 16:00:00') {
      alert('4강은 12월 12일 오후 6시에 시작됩니다.');
    } else if (
      today >= '2025-12-22 18:00:00' &&
      today <= '2025-12-26 16:00:00'
    ) {
      window.open(`${this.voteUrl}/2025/tournament/round-4`, 'aketo', '');
    } else if (today < '2025-12-26 12:00:00') {
      alert('3, 4위전과 결승전은  12월 26일 오후 6시에 시작됩니다.');
    } else if (
      today >= '2025-12-26 18:00:00' &&
      today <= '2025-12-29 12:00:00'
    ) {
      window.open(`${this.voteUrl}/2025/tournament/final`, 'aketo', '');
    } else {
      alert('2025 애캐토의 모든 투표가 종료되었습니다.');
      // alert('다음 투표를 준비중에 있습니다.');
    }
  };
  render() {
    const {
      slideIndex,
      videoUrl,
      duration,
      day,
      hh,
      mm,
      ss,
      open,
      countdown,
      playing,
      chatUrl,
    } = this.state;
    const { imgUrl } = this.props;

    var settings = {
      dots: false,
      //dotsClass: "slick-dots slick-thumb",
      infinite: true,
      //speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 3000,
      //className: 'slide_baner baner_group baner_div1',
      pauseOnFocus: true,
      //fade: true,
      adaptiveHeight: false,
      //centerMode: true,
      initialSlide: 0,

      //variableWidth: true,
      beforeChange: (current, next) => this._beforChange(current, next),
      afterChange: (index) => this._afterChange(index),
    };
    const today = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
    //console.log(charList)
    return (
      <Fragment>
        <div className="event_head">
          <h3>2025 애캐토</h3>
          <button type="button" className="btnClose">
            <img src={'/img/event/event251103/pop_close.png'} alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <div className="event251103">
            {/* 이벤트 내 상속 팝업 */}
            <div
              className="popup"
              style={{ zIndex: 9999, display: open ? '' : 'none' }}
            >
              <div className="popCont">
                <button
                  type="button"
                  className="pop_close"
                  onClick={this._close}
                >
                  <img src={'/img/event/event221117/pop_close.png'} />
                </button>
                <div className="vod">
                  {/*<img src="/img/event/event221117/pop_sample.png"/>*/}
                  {videoUrl === '' ||
                  videoUrl === null ||
                  videoUrl === undefined ? null : isMobile ? (
                    <Fragment>
                      <ReactPlayer
                        ref={(ref) => (this.video = ref)}
                        url={videoUrl}
                        playing={playing}
                        controls
                        muted
                        width={'100%'}
                        height={isMobile ? 320 : 600}
                        //width={isMobile ? 320 : 640}
                      />
                    </Fragment>
                  ) : (
                    <Fragment>
                      <div
                        style={{
                          width:
                            moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                            '2022-12-08 19:30:00'
                              ? '100%'
                              : '75%',
                          float:
                            moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                            '2022-12-08 19:30:00'
                              ? ''
                              : 'left',
                        }}
                      >
                        <ReactPlayer
                          ref={(ref) => (this.video = ref)}
                          url={videoUrl}
                          playing={playing}
                          controls
                          muted
                          width={'100%'}
                          height={700}
                          //width={isMobile ? 320 : 640}
                        />
                      </div>
                    </Fragment>
                  )}
                  {/* <button type="button" className="pop_btn">
                    프로모션 영상보기
                  </button> */}
                </div>
              </div>
            </div>
            {/* 이벤트 상단 메인  */}
            <section className="main">
              <ul className="date">
                <li className="logo">
                  <img src={'/img/event/event251103/logo.png'} alt="애케토" />
                </li>
                <li className="txt">
                  <p>투표기간 : 11/19(수) - 12/29(월)</p>
                  <p>당첨자 발표 : 2026/01/09(금)</p>
                </li>
              </ul>
              {isMobile ? null : moment(new Date()).format(
                  'YYYY-MM-DD HH:mm:ss'
                ) >= '2025-11-13 13:00:00' ? (
                <div
                  style={{
                    width: 200,
                    height: 80,
                    position: 'absolute',
                    top: 25,
                    right: 25,
                    zIndex: 999,
                  }}
                  onClick={this._open}
                >
                  <button type="button" className="rebutton">
                    프로모션 영상보기
                  </button>
                </div>
              ) : null}

              <a
                onClick={this._vote}
                className="btn-main"
                style={{ cursor: 'pointer' }}
              >
                <img
                  src={'/img/event/event251103/backimg_1_btn.png'}
                  alt="투표하기"
                />
              </a>
              {/* <div className="tit">
                <img src={'/img/event/event251103/txt.png'} className="txt" />
              </div> */}
              {/* <div className="vod">
                <div className="mov-01">
                  <img src={'/img/event/event251103/mov01.gif'} alt="" />
                </div>
                <div className="mov-02">
                  <img src={'/img/event/event251103/mov02.gif'} alt="" />
                </div>
                <div className="mov-03">
                  <img src={'/img/event/event251103/mov03.gif'} alt="" />
                </div>
                <div className="mov-04">
                  <img src={'/img/event/event251103/mov04.gif'} alt="" />
                </div>
                <div className="mov-05">
                  <img src={'/img/event/event251103/mov05.gif'} alt="" />
                </div>
                <div className="mov-06">
                  <img src={'/img/event/event251103/mov06.gif'} alt="" />
                </div>
                <div className="mov-07">
                  <img src={'/img/event/event251103/mov07.gif'} alt="" />
                </div>
                <div className="mov-08">
                  <img src={'/img/event/event251103/mov08.gif'} alt="" />
                </div>
              </div> */}

              <div className="visual_bg">
                <img src={'/img/event/event251103/bg.png'} />
              </div>

              <ReactPlayer
                ref={(ref) => (this.video = ref)}
                url={'/img/event/event251103/event_mov.mp4'}
                playing={playing}
                autoplay
                loop
                muted
                controls={false}
                width={'100%'}
                height={'100%'}
                // height={600}
                //width={isMobile ? 320 : 640}
              />
            </section>

            <section className="section evnt1">
              <h2 className="tit">
                <small>올해 당신의 가슴을 울린 캐릭터는 바로..!!</small>
                지금 이 순간, {this.stage} 순위는?
              </h2>
              {countdown ? (
                <ul className="time">
                  <Timer
                    active
                    duration={duration}
                    onTimeUpdate={this.onTimerUpdate}
                    onFinish={this.onFinish}
                  />
                  <li>
                    <div className="day">
                      <span>{day}</span>
                      <small>DAY</small>
                    </div>
                  </li>
                  <li>
                    <div className="hr">
                      <span>{hh}</span>
                      <small>HR</small>
                    </div>
                  </li>
                  <li>
                    <div className="min">
                      <span>{mm}</span>
                      <small>MIN</small>
                    </div>
                  </li>
                  <li>
                    <div className="sec">
                      <span>{ss}</span>
                      <small>SEC</small>
                    </div>
                  </li>
                </ul>
              ) : null}

              <div className="rank_wrap">
                {/* 32강 오픈 전/ */}
                <div className="txtonly">
                  {countdown ? (
                    <div className="txtonly">
                      25년 12월 3일 부터
                      <br />
                      실시간 순위가 집계됩니다.
                    </div>
                  ) : null}
                  {/*isMobile ? (
                    moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                    '2024-11-03 18:40:00' ? (
                      <div
                        style={{
                          width: '80%',
                          height: 80,
                          textAlign: 'center',
                          margin: '10%',
                        }}
                        onClick={this._open}
                      >
                        <button type="button" className="rebutton">
                          프로모션 영상보기
                        </button>
                      </div>
                    ) : null
                  ) : null*/}
                </div>
                {/* 32강 오픈 후/ */}
                {/* moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >= '2024-12-09 16:00:00' && moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <= '2024-12-12 16:00:00'             */}
                {countdown ? null : (
                  <Fragment>
                    <div className="rank_inner">
                      <Slider ref={(ref) => (this.slider = ref)} {...settings}>
                        {this._renderItem()}
                      </Slider>
                    </div>

                    <a
                      style={{ cursor: 'pointer' }}
                      className="arrw prev"
                      onClick={this._onPrev}
                    >
                      이전
                    </a>
                    <a
                      style={{ cursor: 'pointer' }}
                      className="arrw next"
                      onClick={this._onNext}
                    >
                      다음
                    </a>

                    <div className="pagination">
                      {today >= '2025-12-26 18:00:00' && (
                        <>
                          <button
                            type="button"
                            className={slideIndex === 0 ? 'active' : null}
                            onClick={() => this._onGoto(0)}
                          >
                            결승전
                          </button>
                          <button
                            type="button"
                            className={slideIndex === 1 ? 'active' : null}
                            onClick={() => this._onGoto(1)}
                          >
                            3/4위전
                          </button>
                        </>
                      )}

                      {today >= '2025-12-03 16:00:00' &&
                        today < '2025-12-10 16:00:00' && (
                          <>
                            <button
                              type="button"
                              className={slideIndex === 0 ? 'active' : null}
                              onClick={() => this._onGoto(0)}
                            >
                              1조
                            </button>
                            <button
                              type="button"
                              className={slideIndex === 1 ? 'active' : null}
                              onClick={() => this._onGoto(1)}
                            >
                              2조
                            </button>
                            <button
                              type="button"
                              className={slideIndex === 2 ? 'active' : null}
                              onClick={() => this._onGoto(2)}
                            >
                              3조
                            </button>
                            <button
                              type="button"
                              className={slideIndex === 3 ? 'active' : null}
                              onClick={() => this._onGoto(3)}
                            >
                              4조
                            </button>

                            <button
                              type="button"
                              className={slideIndex === 4 ? 'active' : null}
                              onClick={() => this._onGoto(4)}
                            >
                              5조
                            </button>
                            <button
                              type="button"
                              className={slideIndex === 5 ? 'active' : null}
                              onClick={() => this._onGoto(5)}
                            >
                              6조
                            </button>
                            <button
                              type="button"
                              className={slideIndex === 6 ? 'active' : null}
                              onClick={() => this._onGoto(6)}
                            >
                              7조
                            </button>
                            <button
                              type="button"
                              className={slideIndex === 7 ? 'active' : null}
                              onClick={() => this._onGoto(7)}
                            >
                              8조
                            </button>
                          </>
                        )}

                      {today >= '2025-12-10 16:00:00' &&
                        today < '2025-12-17 16:00:00' && (
                          <>
                            <button
                              type="button"
                              className={slideIndex === 0 ? 'active' : null}
                              onClick={() => this._onGoto(0)}
                            >
                              1조
                            </button>
                            <button
                              type="button"
                              className={slideIndex === 1 ? 'active' : null}
                              onClick={() => this._onGoto(1)}
                            >
                              2조
                            </button>
                            <button
                              type="button"
                              className={slideIndex === 2 ? 'active' : null}
                              onClick={() => this._onGoto(2)}
                            >
                              3조
                            </button>
                            <button
                              type="button"
                              className={slideIndex === 3 ? 'active' : null}
                              onClick={() => this._onGoto(3)}
                            >
                              4조
                            </button>
                          </>
                        )}

                      {today >= '2025-12-17 16:00:00' &&
                        today < '2025-12-22 18:00:00' && (
                          <>
                            <button
                              type="button"
                              className={slideIndex === 0 ? 'active' : null}
                              onClick={() => this._onGoto(0)}
                            >
                              1조
                            </button>
                            <button
                              type="button"
                              className={slideIndex === 1 ? 'active' : null}
                              onClick={() => this._onGoto(1)}
                            >
                              2조
                            </button>
                            <button
                              type="button"
                              className={slideIndex === 2 ? 'active' : null}
                              onClick={() => this._onGoto(2)}
                            >
                              3조
                            </button>
                            <button
                              type="button"
                              className={slideIndex === 3 ? 'active' : null}
                              onClick={() => this._onGoto(3)}
                            >
                              4조
                            </button>
                          </>
                        )}
                      {today >= '2025-12-22 18:00:00' &&
                        today < '2025-12-26 18:00:00' && (
                          <>
                            <button
                              type="button"
                              className={slideIndex === 0 ? 'active' : null}
                              onClick={() => this._onGoto(0)}
                            >
                              1조
                            </button>
                            <button
                              type="button"
                              className={slideIndex === 1 ? 'active' : null}
                              onClick={() => this._onGoto(1)}
                            >
                              2조
                            </button>
                          </>
                        )}
                    </div>
                  </Fragment>
                )}
              </div>
              <div style={{ height: 60 }}></div>
            </section>

            <section className="section evnt2">
              <h2 className="tit">
                <small>애캐토 투표 참여하면 혜택이 이렇게나..?!</small>
                참여혜택
              </h2>

              <div className="img_wrap">
                <img
                  src={'/img/event/event251103/backimg_2.png'}
                  className="img_web"
                />
                <img
                  src={'/img/event/event251103/m_backimg_2.png'}
                  className="img_m"
                />
              </div>
            </section>

            <section className="section evnt3">
              <h2 className="tit">
                <small>꾸준히 투표하면 다양한 선물이 팡팡!</small>
                경품안내
              </h2>

              <div className="img_wrap">
                {/* <div className="gift">
                  <img
                    src="/img/event/event251103/gift.png"
                    className="img_web"
                  />
                  <img
                    src="/img/event/event251103/m_gift.png"
                    className="img_m"
                  />
                </div> */}
                <img
                  src={'/img/event/event251103/backimg_3.png'}
                  className="img_web"
                />
                <img
                  src={'/img/event/event251103/m_backimg_3.png'}
                  className="img_m"
                />
              </div>
            </section>

            <section className="section evnt4">
              <h2 className="tit">
                <small>투표 일정 확인하고 마지막 한 표 까지!</small>
                투표 일정 안내
              </h2>

              {/* schdule/ */}
              <VoteSch2025 i={1} />

              <div className="guide">
                <div className="date">
                  진행 기간 : 2025.11.19 (수) ~ 2025.12.29 (월) / 결과 발표 :
                  2025.12.31(수)
                </div>
                <ol>
                  <li>투표는 1계정당 매일 오후 4시에 초기화됩니다.</li>
                  <li>
                    경품 배송은 당첨자 발표 이후 순차적으로 배송될 예정입니다.
                    (기프티콘은 LMS 발송)
                  </li>
                  <li>
                    서비스 종료로 인해 VOD 무료 개방이 되지 않는점 양해바랍니다.
                  </li>
                </ol>
              </div>
            </section>
          </div>

          {/* <div className="event220916_2" style={{ color: '#fff'}}>
                        <div>
                            <div>
                            <ReactPlayer
                                url={videoUrl} 
                                playing 
                                controls 
                                width={'100%'}
                                height={600}
                                //width={isMobile ? 320 : 640}
                            />
                            </div>
                            
                            <div>
                                <iframe src={`https://www.youtube.com/live_chat?v=Yu7qVQorX7o&embed_domain=www.aniplustv.com`} width={"100%"} height={"100%"}></iframe>
                            </div>
                            
                            
                        </div>
                        <div style={{ fontSize: 20, fontWeight: 800}}>
                            <Timer 
                                active 
                                duration={duration} 
                                onTimeUpdate={this.onTimerUpdate} 
                                onFinish={this.onFinish}
                            />
                            <Timecode time={duration - time} format={'HH:mm:ss.SSS'}/>
                         </div>


                        <div>
                            <span style={{ color: slideIndex === 0 ? '#fff' : '#ff5d24'}} onClick={()=>this._onGoto(0)} >1조</span>
                            <span style={{ color: slideIndex === 1 ? '#fff' : '#ff5d24'}} onClick={()=>this._onGoto(1)} >2조</span>
                            <span style={{ color: slideIndex === 2 ? '#fff' : '#ff5d24'}} onClick={()=>this._onGoto(2)} >3조</span>
                            <span style={{ color: slideIndex === 3 ? '#fff' : '#ff5d24'}} onClick={()=>this._onGoto(3)} >4조</span>
                        </div>
                        <Slider ref={(ref) => (this.slider = ref)} {...settings} >
                            { this._renderItem() }
                        </Slider>
                        <div style={{color: '#fff'}} onClick={this._goVote}>투표하기</div>   
                    </div> */}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event2025_aketo));
